const routes = {
  api: {
    uploads: process.env.VUE_APP_URL + '/uploads/images',
    uploads_svg: process.env.VUE_APP_URL + '/uploads/images/svg',
    upload_files: process.env.VUE_APP_URL + '/uploads/files',
    delete_file: process.env.VUE_APP_URL + '/uploads/files/delete/_ID_',
    collections_by_id: 'panel/collections/_ID_',
    collections_showcases: 'panel/showcases',
    collections: 'panel/collections',
    remove_image: 'panel/products/image/_ID_',
    upload_image_api: 'panel/images',
    use_new_all_categories: 'panel/categories/new',
    use_new_all_category_types: 'panel/categories/new/get_category_types',
    show_category_type: 'panel/categories/new/_ID_/show_category_type',
    update_category_type: 'panel/categories/new/_ID_/update_category_type',
    store_categories: 'panel/categories/new',
    update_new_categories: 'panel/categories/new/_ID_/update',
    delete_new_categories: 'panel/categories/new/_ID_/delete',
    show_new_categories: 'panel/categories/new/_ID_/show',
    show_cat_detail: 'panel/categories/new/_ID_/show_detail',
    show_cat_variant: 'panel/categories/new/_ID_/show_variant',
    update_cat_detail: 'panel/categories/new/_ID_/update_detail',
    update_cat_variant: 'panel/categories/new/_ID_/update_variant',
    use_All_Categories: 'panel/categories/all_categories',
    get_notifications: 'panel/get_notifications',
    bot_notifications: 'panel/bot/notifications/_ID_',
    get_bot_notifications: 'panel/bot/notifications/group',
    generate_token: 'panel/bot/notifications/group/generate_token/_ID_',
    show_bot_notif: 'panel/bot/notifications/group/_ID_',
    group_update_users: 'panel/bot/notifications/group/update_users/_ID_',
    bot_refetch_steps: 'panel/bot/notifications/fetch/steps',
    login_to_panel: 'panel/login',
    login_send_code: 'panel/auth',
    logout_panel: 'panel/logout',
    forgot_password: 'panel/reset_password',
    get_admin_users: 'panel/get_admin_user',
    get_call_list: 'panel/reports/user_without_payment',
    call_user: 'panel/users/contacted_with_user/_ID_',

    get_all_roles: 'panel/access/roles',
    store_role: 'panel/access/roles',
    update_role: 'panel/access/roles/_ID_',
    delete_role: 'panel/access/roles/_ID_',
    role_add_user: 'panel/access/roles/add_user/_ID_',
    role_add_permission: 'panel/access/roles/add_permission/_ID_',

    get_all_pages: 'panel/access/pages',
    store_page: 'panel/access/pages',
    update_page: 'panel/access/pages/_ID_',
    delete_page: 'panel/access/pages/_ID_',

    get_all_permissions: 'panel/access/permissions',
    store_permission: 'panel/access/permissions',
    update_permission: 'panel/access/permissions/_ID_',
    delete_permission: 'panel/access/permissions/_ID_',
    get_page_permissions: 'panel/access/permissions/get_page_permissions',
    get_permissions: 'panel/access/get_permissions',

    get_all_users: 'panel/users/users/get_users',
    set_user_password: 'panel/users/reset_password/_ID_',
    get_users_statistic_api: 'panel/users/users/report',
    get_user_info: 'panel/users/users/_ID_',
    get_user_info_totally: 'panel/users/info',
    get_user_payments: 'panel/users/payments/_ID_',
    get_user_payment_receipt: 'panel/users/get_direct_pay/_ID_',
    change_user_payment_receipt_status: 'panel/users/direct_pay/change_status/_ID_',
    get_user_authentication_data: 'panel/users/get_auth/_ID_',
    approve_auth_top_level: 'panel/users/approve_auth_top_level/_ID_',
    get_user_wallet_data: 'panel/users/get_wallet/_ID_',
    get_user_ticket: 'panel/users/ticket/_ID_',
    get_user_discounts: 'panel/users/discounts/_ID_',
    reset_wallet_pending: 'panel/users/reset_wallet_pending/_ID_',
    get_auth_image: 'panel/users/get_auth_images/_ID_',
    change_user_status: 'panel/users/users/change_status/_ID_',
    update_user_manual_delivery_review: 'panel/users/users/manual_delivery_review/_ID_',
    change_user_password: 'panel/users/change_password/_ID_',
    change_user_auth: 'panel/users/approve_auth/_ID_',
    upload_user_auth: 'panel/users/store_auth/_ID_',
    change_wallet_balance: 'panel/users/store_wallet/_ID_',
    check_status_payment: 'panel/payments/verify_payment',
    send_payment: 'panel/payments/sendPayment/_id_/_code_',
    send_payment_dollar: 'panel/payments/sendPaymentDollar/_id_/_code_',
    block_bank_card: 'panel/block_bank_card',
    unblock_bank_card: 'panel/block_bank_card/_ID_',
    mobile_and_card_match: 'panel/users/mobile_and_card_verification',
    checking: 'panel/users/checking',
    refresh_token: 'panel/users/refresh_token',

    users_black_api: 'panel/users/black_lists',
    users_black_api_by_id: 'panel/users/black_lists/_ID_',

    get_all_categories: 'panel/categories/categories',
    get_category: 'panel/categories/categories/_ID_',
    delete_category: 'panel/categories/categories/_ID_',
    store_category: 'panel/categories/categories',
    update_category: 'panel/categories/categories/_ID_',
    reorder_category: 'panel/categories/categories/reorder',
    upload_image: 'panel/categories/categories/upload/image',
    update_category_product_inputs: 'panel/products/update_category_product_inputs/_ID_',

    edit_last_avg_api: 'panel/products/update_avg_setting/_ID_',

    get_categories_with_children: 'panel/products/products/get_categories',
    get_all_products: 'panel/products/get_products',
    get_product_setting: 'panel/products/get_setting',
    get_product_list: 'panel/products/list',
    get_product_status_setting: 'panel/products/get_status_setting',
    store_product_setting: 'panel/products/store_setting',
    store_product_status_setting: 'panel/products/store_status_setting',
    get_all_repository: 'panel/products/repository/_ID_',
    store_repository: 'panel/products/store_repository',
    store_repository_code: 'panel/products/store_repository_code',
    set_hold_status_code: 'panel/products/set_hold_status/_ID_',
    remove_duplication: 'panel/products/remove_duplicate_status/_ID_',
    store_many_repository_code: 'panel/products/store_many_repository',
    get_information: 'panel/products/repository/_ID_/get_information',
    api_gift_request_list: 'panel/api_gift/request/list',
    api_gift_request_by_id: 'panel/api_gift/request/_ID_',
    api_gift_request_delete_all: 'panel/api_gift/request/delete_all',
    api_gift_request_status_by_id: 'panel/api_gift/request/status/fetch/_ID_',
    api_gift_request_all_status: 'panel/api_gift/request/status/fetchAll',
    manual_buy_api: 'panel/products/buy_from_api',
    delete_repository: 'panel/products/delete_repository',
    store_product: 'panel/products/products',
    change_product_status: 'panel/products/change_available_status',
    get_product: 'panel/products/products/_ID_',
    update_product: 'panel/products/products/_ID_',
    delete_product: 'panel/products/products/_ID_',
    upload_product_image: 'panel/products/products/upload/image',
    get_history_images: 'panel/products/get_history_images',
    get_structure: 'panel/bills/get_structure/_ID_',
    get_faq_list: 'panel/setting/faq_list',
    faq_api: 'panel/setting/faq_store/_ID_',
    delete_faq: 'panel/setting/faq_delete/_ID_',
    get_all_structure: 'panel/setting/structures',
    bot_mapping: 'panel/bot/accounts/mapping',
    bot_mapping_by_id: 'panel/bot/accounts/mapping/_ID_',
    bot_account_list: 'panel/bot/accounts/list',
    bot_account_fetch: 'panel/bot/accounts/fetch',
    store_structure: 'panel/setting/structures',
    update_structure: 'panel/setting/structures/_ID_',
    delete_structure: 'panel/setting/structures/_ID_',
    store_gate: 'panel/gates',
    get_all_gate: 'panel/gates',
    get_selected_gates: 'panel/gates/org',
    update_selected_gates: 'panel/gates/org/_ID_',
    get_all_disable_gate: 'panel/gates?is_enable=0',
    update_gate: 'panel/gates/_ID_',
    delete_gate: 'panel/gates/org/_ID_',
    reorder_gate: 'panel/gates/reorder',
    get_config: 'panel/setting/configs',
    store_policy: 'panel/setting/store_policy',
    get_payment_setting: 'panel/setting/payment_settings',
    store_payment_setting: 'panel/setting/payment_settings',
    wallet_manage: 'panel/setting/wallets',
    total_users_wallet: 'panel/setting/wallets/total_users',
    wallet_charge_info: 'panel/setting/wallet_charge_info',
    get_api_products: 'panel/api_gift/get_products',
    reload_products: 'panel/api_gift/reload_products',
    get_local_products: 'panel/api_gift/get_local_products',
    product_mapping: 'panel/api_gift/store_product_mapping',
    get_mapping_product_setting: 'panel/api_gift/get_product_setting',
    save_mapping_product_setting: 'panel/api_gift/store_product_setting',
    check_repository: 'panel/check_repo',
    get_product_inputs: 'panel/products/get_product_inputs/_ID_',
    update_product_inputs: 'panel/products/update_product_inputs/_ID_',
    get_api_main_categories: 'panel/api_gift/get_main_categories',
    get_api_categories: 'panel/api_gift/get_categories',
    get_local_categories: 'panel/api_gift/get_local_categories',
    reload_categories: 'panel/api_gift/reload_categories',
    category_mapping: 'panel/api_gift/store_category_mapping',
    get_api_wallet: 'panel/api_gift/get_wallet',
    get_api_setting: 'panel/api_gift/get_setting',
    change_api_setting: 'panel/api_gift/change_setting',

    get_tebyan_Wallet_output: 'panel/reports/teb_output',
    request_tebyan_wallet_output: 'panel/reports/teb_request_output',

    get_tebyan_Wallet: 'panel/reports/teb_wallet_report',
    reload_tebyan_wallet: 'panel/reports/teb_get_last_amount',

    replace_code_change: 'panel/reports/replace_code_change_status/_ID_',
    get_report_replace_code: 'panel/reports/replace_code_report',
    get_report_sell: 'panel/reports/sell_report',
    get_report_cortex: 'panel/reports/cortex',
    get_cortex_export: 'panel/reports/cortex_export',
    get_report_sell_usd: 'panel/reports/sell_report_with_usd',
    get_sell_report_export: 'panel/reports/sell_report_export',
    get_sell_report_export_usd: 'panel/reports/sell_report_with_usd_export',
    payment_report_export: 'panel/reports/payment_report_export',
    product_export: 'panel/products/get_products_export',
    inventory_report_export: 'panel/reports/inventory_report_export',
    profit_report_export: 'panel/reports/profit_report_export',
    get_inventory_report: 'panel/reports/inventory_report',
    get_profit_report: 'panel/reports/profit_report',
    buy_report: 'panel/reports/buy_report',
    get_buy_report_export: 'panel/reports/buy_report_export',
    payments_count_report: 'panel/reports/payment_report_count',
    call_report: 'panel/reports/user_call',
    user_churn: 'panel/reports/user_churn',
    user_churn_excel: 'panel/reports/user_churn_excel',
    users_count_report: 'panel/reports/user_report_count',
    get_bank_wage: 'panel/setting/bank_wage',
    update_bank_wage: 'panel/setting/bank_wage/_ID_',
    product_deliver_report: 'panel/reports/deliver',
    support_activity_report: 'panel/reports/support_activity',
    payment_yearly_report: 'panel/reports/payment_yearly_report',
    ticket_report: 'panel/reports/tickets_statistics',
    ticket_count: 'panel/reports/all_tickets_count',
    support_users: 'panel/users/get_support_users',
    support_sms_template: 'panel/support_sms_template',
    send_sms_to_support: 'panel/send_sms_to_support/_ID_',
    get_report_revenue: 'panel/reports/marketing_user_payment',
    get_report_payments_users: 'panel/reports/payments_and_users',
    change_image_by_category: 'panel/products/change_image_by_category/_CATEGORY_ID_/_IMAGE_ID_',

    get_payments_all: 'panel/payments/get_payments',
    get_payments_sum: 'panel/payments/sum',
    show_bill: 'panel/bills/_ID_',
    get_bills: 'panel/bills/get_bills',
    get_dashboard_chart_data: 'panel/get_dashboard_data',
    conditional_returns: 'panel/bills/_ID_/conditional-returns',
    conditional_return_approve: 'panel/bills/conditional-returns/_RETURN_/items/_ITEM_/approve',
    conditional_returns_index: 'panel/bills/conditional-returns',
    conditional_return_notification_read: 'panel/bills/conditional-return-notifications/_ID_/read',
    bill_cancel: 'panel/bills/bill_cancel',
    bill_send: 'panel/bills/bill_send/_ID_',
    bill_send_manual_again: 'panel/bills/bill_send_manual_again/_ID_',
    use_internal_mapping: 'panel/bills/use_internal_mapping',
    hold_list: 'panel/products/holds',
    search_code: 'panel/check_code',
    cancel_products: 'panel/payments/payment_ID_/product_ID_/cancel',
    confirm_send_sms: 'panel/bills/send_sms/_ID_',
    replace_code: 'panel/bills/replace_code',
    user_access_code: 'panel/setting/user_access_code',
    user_access_code_id: 'panel/setting/user_access_code/_ID_',
    get_code: 'panel/bills/user_access_code/get_code',
    get_note: 'panel/notes',
    get_note_id: 'panel/notes/_ID_',
    delivery_manual_change: 'panel/bills/delivery_manual_change',

    get_tickets: 'panel/tickets/get_tickets',
    get_code_details: 'panel/tickets/get_code_details',
    get_by_id_ticket: 'panel/tickets/show_ticket/_ID_',
    answer_ticket: 'panel/tickets/store_answer/_ID_',
    close_ticket: 'panel/tickets/close_ticket/_ID_',
    pending_ticket: 'panel/tickets/pending_ticket/_ID_',
    store_ticket_for_user: 'panel/tickets/store_ticket_for_user',
    store_code_report_for_user: 'panel/tickets/store_code_report_for_user',
    get_all_tickets_template: 'panel/tickets/templates',
    store_tickets_template: 'panel/tickets/templates',
    update_tickets_template: 'panel/tickets/templates/_ID_',
    delete_tickets_template: 'panel/tickets/templates/_ID_',
    get_tickets_response_report: 'panel/reports/tickets_response',
    get_tickets_response_report_admin: 'panel/reports/tickets_response_admin',
    apigift_reported: 'panel/tickets/apigift_reported',
    get_folder_list: 'panel/ticket_folder/select_box/list',
    get_accounting_contacts_list: 'panel/select_box/accounting_contacts',
    update_ticket_folder: 'panel/tickets/update/folder/_ID_',

    get_api_gift_ticket_show: 'panel/api_gift/ticket/show/_ID_',
    get_api_gift_ticket_show_offline: 'panel/api_gift/ticket/show/offline/_ID_',
    get_api_gift_ticket_reply: 'panel/api_gift/ticket/reply/_ID_',
    get_api_gift_ticket_create: 'panel/api_gift/ticket/create/_ID_',
    get_api_gift_ticket_mediation_request: 'panel/api_gift/ticket/mediation_request/_ID_',
    close_api_gift_ticket: 'panel/api_gift/ticket/close/_ID_',

    get_logs_api: 'panel/logs/get_api_logs',
    get_buy_log: 'panel/api_gift/get_buy_log',
    get_audit_logs: 'panel/logs/get_audit_logs',
    get_audit_log_components: 'panel/logs/get_audit_log_components',
    get_bills_logs: 'panel/bills/log/report',

    get_mapping: 'panel/setting/get_mappings',
    store_mapping: 'panel/setting/store_mappings',
    setting_get_mappings_internal: 'panel/setting/get_mappings/internal/_ID_',
    setting_get_mappings_external: 'panel/setting/get_mappings/external/_ID_',
    get_api_gift_products_list: 'panel/api_gift/products/list',

    get_product_categories: 'panel/get_product_categories',
    update_tickets: 'panel/tickets/edit_answer/_ID_',

    discount_code: 'panel/discounts',
    discount_code_by_id: 'panel/discounts/_ID_',
    setting_discount_code: 'panel/discounts/configs',
    get_setting_discount_code: 'panel/discounts/configs/index',
    setting_discount_code_by_id: 'panel/discounts/configs/_ID_',
    discount_code_by_support: 'panel/users/discounts/_ID_',

    short_links: 'panel/short_links',
    short_links_by_id: 'panel/short_links/_ID_',

    limit_discount_code: 'panel/limit/discounts',
    limit_discount_code_by_id: 'panel/limit/discounts/_ID_',
    limit_setting_discount_code: 'panel/limit/discounts/configs',
    limit_get_setting_discount_code: 'panel/limit/discounts/configs/index',
    limit_setting_discount_code_by_id: 'panel/limit/discounts/configs/_ID_',
    limit_discount_code_by_support: 'panel/users/discounts/_ID_',

    get_versions: 'panel/version_history',
    store_version: 'panel/version_history',

    two_factor_authentication: 'panel/users/two_factor_authentication',
    comments: 'panel/comments',
    tokens: 'panel/tokens',

    login_notice: 'panel/config_login',

    get_admin_user: '/panel/get_admin_user',
    auth_user_templates: 'panel/setting/auth_user_templates',
    support_description: 'panel/bills/log',
    edit_payment_product_infomation: 'panel/bills/payment_product/infomation/edit/_ID_',
    get_status_inquiry: 'panel/bot/product_request/_ID_',
    get_redirect_list: 'panel/products/redirect/list',
    update_product_details: 'panel/products/detail/_ID_',
    get_product_categoreis: 'panel/products/getProductCategories/_ID_',
    get_products_seo_list: 'panel/products/seo/list',
    get_bill_info: 'panel/bills/bill/_ID_',
    get_bill_setting_info: 'panel/bill_config',
    get_security_code: 'panel/security',
    get_security_code_by_id: 'panel/security/_ID_',
    store_fake_comment: 'panel/comments/fake',
    accounting_settings: 'panel/accounting/setting',
    accounting_sync: 'panel/accounting/sync',
    accounting_year: 'panel/accounting/year',
    accounting_products: 'panel/accounting/product/many',
    accounting_opening_quantity: 'panel/accounting/product/opening_quantity',
    accounting_category: 'panel/accounting/product/many_category/_ID_',
    accounting_contacts: 'panel/accounting/contact',
    accounting_opening_quantity_cat: 'panel/accounting/product/opening_quantity_category/_ID_',
    accounting_banks: 'panel/accounting/bank',
    accounting_banks_fetch: 'panel/accounting/bank/fetch',
    bank_select_box: 'panel/select_box/banks',

    auth_user_samples: 'panel/setting/auth_user_samples',
    auth_user_sample_by_id: 'panel/setting/auth_user_samples/_ID_',

    mobile_app_main_categories: 'panel/mobile_app_main_categories',
    mobile_app_main_categories_by_id: 'panel/mobile_app_main_categories/_ID_',
    select_box_sub_categories: 'panel/select_box/categories',
    mobile_app_slider: 'panel/mobile_app_slider',
    mobile_app_slider_by_id: 'panel/mobile_app_slider/_ID_',
    app_update_cache: 'panel/mobile_app/update_cache',
    app_category_reorder: 'panel/mobile_app_slider/reorder',

    use_new_all_category_type_filters: 'panel/categories/new/category-type-filters',
    show_category_type_filter: 'panel/categories/new/category-type-filters/_ID_',
    update_category_type_filter: 'panel/categories/new/category-type-filters/_ID_',
  },
}
const routeGetters = {
  routeApi: state => url => state.api[url],
}
export default {
  state: routes,
  getters: routeGetters,
}
